'use strict';

const INVOICE_SOURCE = {
    DRUG_STORE: 'DRUG_STORE',
    ONLINE: 'ONLINE',
    CALL_CENTER: 'CALL_CENTER'
};

let timer = null;

/**
 * Handles the selection of a drug store by updating the anchor link and setting a timeout to redirect.
 *
 * @param {jQuery} $selector - The jQuery object representing the selected drug store element.
 * @property {string} data-invoice-redirection-url - The URL to redirect to for the invoice.
 * @property {string} data-invoice-redirection-time - The time in seconds to wait before redirecting.
 */
const handleSelectedDrugStore = ($selector) => {
    const iconUrl = $selector.data('icon-url');
    const redirectUrl =  $selector.data('invoice-redirection-url');
    const redirectTime = $selector.data('invoice-redirection-time');
    
    $selector.find('.drug-store-icon').attr('src', iconUrl);
    const $anchor = $selector.find('.invoice-site-link').first();
    
    if ($anchor.length) {
        $anchor.attr('href', redirectUrl);
        $selector.find('.redirect-wait span').text(redirectTime);
        const timeout = Number(redirectTime) * 1000;
        // Start the timeout to open invoice site
        timer = setTimeout(() => {
            window.open(redirectUrl, '_newtab')
        }, timeout);
    }
}

/**
 * Displays the invoice source content based on the provided source.
 * 
 * This function hides all the invoice source options content and then shows
 * the content that matches the provided source. If the source is 'DRUG_STORE',
 * it also handles the selected drug store content.
 * 
 * @param {string} source - The source of the invoice to be displayed. 
 *                          It should match one of the data-invoice-source attributes.
 */
const showInvoiceSource = (source) => {
    const $container = $('.invoice-source-container');
    // Hides all the invoice source options content
    $container.find('.invoice-source-asset').addClass('d-none');
    // Shows the matched content
    const $selectedContent = $container.find(`.invoice-source-asset[data-invoice-source='${source}']`);
    $selectedContent.removeClass('d-none');

    if (source === INVOICE_SOURCE.DRUG_STORE) {
        handleSelectedDrugStore($selectedContent);
    }
}

/**
 * Handles the change event for a select element.
 * 
 * This function is triggered when the selected option of a select element changes.
 * It retrieves the selected value, resets a timer, and calls the showInvoiceSource function
 * with the selected value.
 * 
 * @param {Event} event - The change event triggered by the select element.
 */
const handleSelectChange = (event) => {
    const selectedValue = $(event.currentTarget).val();
    // Reset the timer when new option is selected
    clearTimeout(timer);
    showInvoiceSource(selectedValue);
}

/**
 * Initializes the events for generating an invoice.
 * 
 * This function sets up an event listener on a select element within the 
 * generate-invoice container. When the select element's value changes, 
 * the handleSelectChange function is called. If a default invoice source 
 * is already selected, it will be displayed using the showInvoiceSource function.
 * 
 * @function
 */
const initGenerateInvoiceEvents = () => {
    const $select = $('.generate-invoice .select-container select');

    if (!$select.length) {
        return;
    }

    $select.on('change', handleSelectChange);
    const defaultInvoiceSource = $select.val();

    if (defaultInvoiceSource) {
        showInvoiceSource(defaultInvoiceSource);
    }
}

module.exports = {
    initGenerateInvoiceEvents
}